import styled, { css } from 'styled-components';
import { Scrollbar } from '../../atoms';
import { Paper } from '../../atoms/Paper';

export const Container = styled.div`
  position: relative;
  display: inline-block;
`;

export const Arrow = styled.div`
  position: absolute;
  top: -14px;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 14px solid ${({ theme }) => theme.colors.white};
  width: 0;
  height: 0;

  filter: drop-shadow(0 0px 2px rgb(0 0 0 / 30%));
`;

export const Card = styled(Paper)<{
  offsets: { left: number; right: number };
  alignment: 'left' | 'right';
}>`
  position: absolute;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 3px;

  &.card {
    ${({ alignment, offsets }) =>
      alignment === 'right' &&
      css`
        right: ${-(offsets.left + 16)}px;

        & ${Arrow} {
          right: ${offsets.left + 16}px;
        }
      `}

    ${({ alignment, offsets }) =>
      alignment === 'left' &&
      css`
        left: ${-(offsets.right + 16)}px;

        & ${Arrow} {
          left: ${offsets.right + 16}px;
        }
      `}
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  background-color: #fff;
  border-radius: 3px;
  padding: 1rem;
  z-index: 10;
  overflow-y: auto;
  max-height: 10rem;
  min-width: 10rem;

  ${Scrollbar.secondary}
`;
